import React from 'react'
import { useLocation, useParams, Outlet } from 'react-router-dom'
import PlaylistLoadingContainer from './index'

/**
 * PlaylistWithTracksLoadingContainer component for loading playlists with tracks
 *
 * A specialized wrapper around PlaylistLoadingContainer that specifically waits
 * for both playlist metadata and track data to be loaded before rendering children.
 *
 * @returns JSX element containing the playlist loading container with tracks enabled
 */

const PlaylistWithTracksLoadingContainer = (): React.ReactNode => {
  const location = useLocation()
  const params = useParams()

  return (
    <PlaylistLoadingContainer withTracks={true}>
      <Outlet />
    </PlaylistLoadingContainer>
  )
}

export default PlaylistWithTracksLoadingContainer
